<template>
  <div class="level is-mobile">
    <div class="level-left">
      <div class="level-item is-flex align-items-center table-controls-left">
        <SearchInput
          v-if="isSearchEnabled"
          v-model="searchValue"
          :disabled="disabled"
          :data-e2e="TableCypressAttribute.inputs.SEARCH"
        />
        <div class="is-flex align-items-center control m-l-10">
          <slot name="custom-controls" v-bind="$props" />
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="is-flex control m-l-10 m-t--2">
        <slot name="custom-controls-right" v-bind="$props" />
      </div>
      <div class="level-item" :data-e2e="TableCypressAttribute.views.TABLE_ACTION">
        <slot name="table-actions" v-bind="$props"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { TableCypressAttribute } from '/@/modules/core/table/constants/TableCypressAttribute';
import SearchInput from '/@/modules/core/table/components/SearchInput.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TableControl',
  emits: ['search-change'],
  slotsDefinition: {
    customControls: {},
    customControlsRight: {},
    tableActions: {}
  },
  components: {
    SearchInput
  },
  props: {
    total: Number,
    isAsyncData: Boolean,
    disabled: Boolean,
    isSearchEnabled: { type: Boolean, default: false },
    searchChange: Function
  },
  static: {
    TableCypressAttribute
  },
  data() {
    return {
      showTable: true,
      searchValue: null,
      currentViewType: this.selectedViewType,
      isFilterActive: false
    };
  },
  methods: {
    onSearchChange(value) {
      this.$emit('search-change', value);
    }
  },
  created() {
    this.debounceQuery = debounce(this.onSearchChange, this.isAsyncData ? 1000 : 0);
  },
  watch: {
    searchValue(value) {
      this.debounceQuery(value);
    }
  }
};
</script>

<style scoped>
.level {
  padding-bottom: 0;
  margin-bottom: var(--ce-10-5px);

  span.select {
    font-size: var(--ce-12-6px);
    margin-top: 1px;
    float: right;

    select {
      color: var(--ce-grey);
      border: 0;

      &:focus {
        box-shadow: none;
      }
    }
  }

  &.is-loading {
    position: relative;
    pointer-events: none;

    &:after {
      position: absolute;
      top: 4em;
      left: calc(50% - 2.5em);
      width: 5em;
      height: 5em;
      border-width: 0.25em;
    }
  }
}
@media (max-width: CE_MOBILE) {
  :deep(.search-field) {
    @media (max-width: CE_MOBILE) {
      height: var(--ce-50px) !important;
      margin-bottom: 0 !important;
      border-radius: var(--ce-radius-large) !important;
    }
  }
}

:deep(span.icon) {
  @media (max-width: CE_MOBILE) {
    top: var(--ce-2px) !important;
  }
}

.table-controls-left {
  align-items: center;

  > .control {
    align-items: center;
  }
}
</style>
